import React from "react";
import styled, { keyframes } from "styled-components";
import bannerWide from "src/assets/images/home/bannerNew_wide.jpeg";
import bannerMobile from "src/assets/images/home/bannerNew_mobile.jpeg";

interface BannerDialogProps {
  open: boolean;
  onClose: () => void;
  isMobile: boolean;
}

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 64, 0.5);
  backdrop-filter: blur(4px);
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  animation: ${fadeIn} 0.2s ease;
`;

const Card = styled.div`
  position: relative;
  max-width: 900px;
  width: 100%;
  background: var(--card-bg);
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-xl);
  animation: ${slideUp} 0.3s ease;
`;

const BannerImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

const CTABar = styled.div`
  display: flex;
  justify-content: center;
  padding: var(--space-4);
  background: linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%);
`;

const CTAButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  background: #fff;
  color: #d6249f;
  padding: 10px 32px;
  border-radius: 50px;
  text-decoration: none;
  font-family: var(--font-display);
  font-size: 1rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: var(--transition);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  color: var(--navy);
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  z-index: 2;
  transition: var(--transition);
  box-shadow: var(--shadow-md);

  &:hover {
    background: var(--red);
    color: #fff;
  }
`;

const BannerDialog: React.FC<BannerDialogProps> = ({ open, onClose, isMobile }) => {
  if (!open) return null;

  return (
    <Overlay onClick={onClose}>
      <Card onClick={(e) => e.stopPropagation()}>
        <CloseBtn aria-label="Fechar" onClick={onClose}>
          ✕
        </CloseBtn>
        <BannerImage
          src={isMobile ? bannerMobile : bannerWide}
          alt="Banner promocional"
        />
        <CTABar>
          <CTAButton
            href="https://intheguard.com.br/"
            target="_blank"
            rel="noopener noreferrer"
          >
            COMPRE SEU IN THE GUARD
          </CTAButton>
        </CTABar>
      </Card>
    </Overlay>
  );
};

export default BannerDialog;
